import _ from 'lodash';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Field } from 'redux-form';
import React, { useEffect, useState } from 'react';
import { renderDropdownList } from '../FormFields/reduxFormRenderers';
import { MultiselectField, NumberField } from './index';
import { useSelector } from 'react-redux';
import { getOfferSelector } from '../../reducers/OfferTitleReducer';
import { sequenceDetailsSelector } from '../../views/Sequences/actions/reducers';
import { getFormSelector } from '../../reducers/FormSelectorReducer';

const InternalSuppressionItem = ({ name, criteriaType, offers, offerActions, loadingOffers, offerActionsLoading }) => {
  const [suppressionTypeData, setSuppressionTypeData] = useState([]);
  const [showAnswers, setShowAnswers] = useState(false);

  const alphabitizedOffers = _.orderBy(offers, ['name'], ['asc']);
  const alphabitizedOfferActions = _.orderBy(offerActions, ['title'], ['asc']);

  const offerType = useSelector((state) => state.offerState && state.offerState.form);
  const suppressionRules = useSelector((state) => getOfferSelector()(state, 'suppressionRules'));

  const limitAnswers = useSelector((state) => {
    return (
      getOfferSelector()(state, 'questionAnswers')
        ?.map((questionAnswer) => questionAnswer.text)
        ?.filter(Boolean) || []
    );
  });

  // const prePingSuppressionType = useSelector((state) =>
  //   getOfferSelector()(state, `${name}.prePingSuppressionType`)
  // );

  // const prePingSuppressionLevel = useSelector((state) =>
  //   getOfferSelector()(state, `${name}.prePingSuppressionLevel`)
  // );

  const prePingSuppressionType = useSelector((state) => {
    const formSelector = state?.form?.sequenceDetails ? sequenceDetailsSelector : getFormSelector();
    if (!formSelector) {
      console.warn('Form selector not found in state');
      return {};
    }
    return formSelector(state, `${name}.prePingSuppressionType`);
  });

  const prePingSuppressionLevel = useSelector((state) => {
    const formSelector = state?.form?.sequenceDetails ? sequenceDetailsSelector : getFormSelector();
    if (!formSelector) {
      console.warn('Form selector not found in state');
      return {};
    }
    return formSelector(state, `${name}.prePingSuppressionLevel`);
  });

  const offerActionType = useSelector((state) => {
    return state?.form?.offerActionDetail?.values?.offerActionType;
  });

  const shouldRenderSuppression = prePingSuppressionType && prePingSuppressionType.toLowerCase() !== 'none';

  useEffect(() => {
    if (prePingSuppressionLevel === 'answer') {
      setShowAnswers(true);
    }
    if (criteriaType === 'Offer Action Criteria') {
      if (offerActionType === 'LINKOUT') {
        setSuppressionTypeData([
          'select',
          'none',
          'action_taken',
          'revenue_generated',
          'email_redirect',
          'email_redirect_rev_generated',
        ]);
      } else {
        setSuppressionTypeData(['select', 'none', 'action_taken', 'revenue_generated']);
      }
    } else if (offerType === 'offerquestion' || offerType === 'offerform') {
      setSuppressionTypeData(['select', 'none', 'calculated_revenue', 'accepted', 'impression', 'answer']);
    } else {
      setSuppressionTypeData(['select', 'none', 'calculated_revenue', 'accepted', 'impression']);
    }
  }, [suppressionRules, offerType, criteriaType, offerActionType]);
  return (
    <>
      <Typography variant='h6'>Suppression Item</Typography>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
            Type
          </FormLabel>
          <Field
            name={`${name}.prePingSuppressionType`}
            component={renderDropdownList}
            type='select'
            defaultValue='none'
            data={['none', 'days', 'hours', 'minutes']}
          />
        </Grid>
        {shouldRenderSuppression && (
          <>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Field name={`${name}.prePingSuppressionAmount`} component={NumberField} label='Amount' />
            </Grid>
            <Grid size={{ xs: 12, sm: showAnswers ? 4 : 6 }}>
              <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                Level
              </FormLabel>
              <Field
                name={`${name}.prePingSuppressionLevel`}
                component={renderDropdownList}
                type='select'
                defaultValue='select'
                data={suppressionTypeData}
                onChange={(e) => {
                  setShowAnswers(e === 'answer');
                }}
              />
            </Grid>
            {showAnswers && (
              <Grid size={{ xs: 12, sm: 4 }}>
                <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                  Answer
                </FormLabel>
                <Field
                  name={`${name}.prePingSuppressionAnswer`}
                  component={renderDropdownList}
                  type='select'
                  defaultValue=''
                  data={limitAnswers}
                />
              </Grid>
            )}
            <Grid size={{ xs: 12, sm: showAnswers ? 4 : 6 }}>
              <Field name={`${name}.prePingSuppressionMaxLimit`} component={NumberField} label='Max Limit' />
            </Grid>
          </>
        )}
      </Grid>
      <Grid container spacing={2} sx={{ alignItems: 'start' }}>
        {shouldRenderSuppression &&
          criteriaType.toLowerCase() != 'offer wall ad criteria' &&
          criteriaType.toLowerCase() != 'sequence' && (
            <Grid size='grow'>
              <FormLabel component='span' sx={{ display: 'block', mb: 0.5 }}>
                Additional {criteriaType !== 'Offer Action Criteria' ? 'Offers' : 'Offer Actions'}
              </FormLabel>
              <Field
                name={
                  criteriaType !== 'Offer Action Criteria'
                    ? `${name}.additionalOffers`
                    : `${name}.additionalOfferActions`
                }
                component={MultiselectField}
                loading={loadingOffers || offerActionsLoading}
                data={criteriaType !== 'Offer Action Criteria' ? alphabitizedOffers : alphabitizedOfferActions}
                valueField='id'
                textField={criteriaType !== 'Offer Action Criteria' ? 'name' : 'title'}
                isLoading={loadingOffers || offerActionsLoading}
              />
            </Grid>
          )}
      </Grid>
    </>
  );
};

export default InternalSuppressionItem;
